import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ExamService} from '../../../../services/exam/exam.service';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-second-reading',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './second-reading.component.html',
  styleUrls: ['./second-reading.component.scss']
})
export class SecondReadingComponent implements OnInit, OnDestroy {

  @Input() idLevel: string;
  @Output() eventEmitter = new EventEmitter<string>();
  questions: any[] = [];

  answers: { [key: string]: string | undefined } = {};
  letters: string[] = ['A', 'B', 'C', 'D', 'E', 'F'];
  constructor(
    private examSrv: ExamService
  ) { }

  trackByIndex(index: number) { return index; }

  async ngOnInit(): Promise<void> {
    // Generate questions
    this.questions = await this.examSrv.generate(this.idLevel, 'SECOND_READING');
    this.questions.forEach((question) => {
      question.sentences.forEach((sentence) => {
        this.answers[sentence.uniqid] = undefined;
      });
    });
  }

  selectAnswer(question, answer): void {
    this.answers[question.uniqid] = answer.uniqid;
  }

  isSelected(question, answer): boolean {
    return this.answers[question.uniqid] === answer.uniqid;
  }

  isAnswered(question): boolean {
    return this.answers[question.uniqid] !== undefined;
  }

  getIndex(i: number, j: number): number {
    let index = 0;

    for (let k = 0; k < i; k++) {
      index += this.questions[k].sentences.length;
    }

    return index + j + 1;
  }

  next(): void {
    this.eventEmitter.emit('SECOND_READING');
  }

  async ngOnDestroy(): Promise<void> {
    await this.examSrv.submit(this.idLevel, {
      answers: this.answers,
      type: 'SECOND_READING'
    });
  }
}
